<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <!--  新增按钮      -->
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="addMenu" >新增菜谱</el-button>
            <!-- 搜索区域-->
            <div style="margin-right: 20px">
                <span class="titlew" >选择日期</span>
                <el-date-picker size="mini" style="width: 150px"
                                v-model="startDate"
                                type="date"
                                @blur="startChange"
                                placeholder="开始日期"
                                value-format="yyyy-MM-dd"
                                clearable
                >
                </el-date-picker>
                <span class="titlew" >至</span>
                <el-date-picker size="mini" style="width: 150px "
                                v-model="endDate"
                                type="date"
                                @blur="endChange"
                                :picker-options="endDateLimit"
                                clearable
                                value-format="yyyy-MM-dd"
                                placeholder="结束日期"
                >
                </el-date-picker>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>

        </div>
        <!--  表格  -->
        <el-table
                id="eltable"
                ref="ftable"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"
                :highlight-current-row="true"
        >
            <el-table-column type="index" :index="hIndex" label="序号" width="100"/>

            <el-table-column
                    prop="datePeriod"
                    :label="$t('form_date')"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="state"
                    label="状态"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.state==1">已发布</span>
                    <span v-if="scope.row.state==0">未发布</span>
                </template>
            </el-table-column>
<!--            <el-table-column-->

<!--                    show-oveflow-tooltip>-->
<!--                <template slot-scope="scope">-->
<!--                    <span >{{scope.row.week}}周</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                    width="250"
                    label="操作">
                <template slot-scope="scope" >
                    <div>
                        <el-button  type="text" size="mini" @click="editDish(scope.row)">编辑</el-button>
                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>
                        <el-button  type="text" size="mini" @click="cprelease(scope.row)" :disabled="scope.row.state==1?true:false">确认发布</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!-- 父表格 -->

        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <!--
                    small：是否使用小型分页样式
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：总条目数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔
                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10,20,30,40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <!--
                    small：是否使用小型分页器
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：条目总数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔
                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->

                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 分页器-->
        <!--  新增菜品弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold;margin-top: -350px"
                top="350px"
                width="100rem"

                :title="title"
                :visible.sync="addDialog"
                v-if="addDialog"
        >
            <addMenu :moren="moren" @close="close" :editbtn="editbtn" :editData1 = "editData" :title="title" @getList="getList" :dateList="dateList" :editShow1="editShow"></addMenu>
        </el-dialog>

        <!--  弹窗  -->
        <!--  删除产线弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialog"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialog"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialog = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
        <!--  发布弹窗  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="releaseDialog"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="releaseDialog"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{releasedetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="releaseDialog = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitrelease">确 定</el-button>
  </span>
        </el-dialog>

    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import addMenu from "./component/addMenu";

    export default {
        name: "menuRelease",
        components:{
            addMenu
        },

        data(){
            return{
                delDialog:false,
                releaseDialog:false,
                release:false,
                flowPath:false,

                editData:{},
                editShow:false,
                startDate:'',
                endDate:'',
                addDialog:false,//编辑弹窗
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                baseerp:'',
                foodType:'',
                cpTypedata:{},
                endDateLimit: {
                    disabledDate: (time) => {
                        if(this.startDate!= ""){
                            return time.getTime() < new Date(this.startDate).getTime()-8.64e7//禁用开始日期之前的日期,如果没有后面的-8.64e6就是不可以选择今天的
                        }
                    }
                },
                // startDateLimit: {
                //     disabledDate: (time) => {
                //         if(this.endDate!= ""){
                //             return time.getTime() > new Date(this.endDate).getTime()//禁用开始日期之前的日期
                //         }
                //     }
                // },
                // tableData: [
                //     {name:"包子",foodType:0,price:2,pic:""},
                //     {name:"鱼香肉丝",foodType:1,price:17,pic:""}
                // ],
                tableData:[],
                dateList:[],
                tableHeight:0,//列表高度
                title:'',
                releaseDate:'',
                addbtn:false,
                editbtn:1,
                moren:''
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            // this.getDataDict()
            this.getList()

            this.$nextTick(()=>{
                this.onResize();

            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp


        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            hIndex(index) {
                // 当前页数 - 1 * 每页数据条数 + index + 1 （ index 是索引值，从0开始）
                return (this.currentPage - 1) * this.pageSize + index + 1
            },
            startChange(){
                if(this.endDate!=''){
                    if(this.endDate<this.startDate){
                        this.startDate=''
                        this.$message.error('请选择小于或等于结束日期的值')
                    }
                }
            },
            endChange(){
                if(!this.startDate && this.endDate){
                    this.endDate=''
                    this.$message.error('请先选择开始日期')
                }
                if(this.endDate&&this.endDate<this.startDate){
                    this.endDate=''
                    this.$message.error('请选择大于或等于开始日期的值')
                }
            },

            clist(){
                this.tableData.forEach(item=>{
                    this.$refs.ftable.toggleRowExpansion(item,false)
                })
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

            },
            ...mapActions(["getCurrentMenuId"]),

            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;
            },

            //关闭弹框
            close(){
                this.flowPath=false
                this.addDialog=false
            },
            //页面搜索
            Search(){
                if(!this.startDate&&!this.endDate){
                    this.getList()
                }else if(!this.endDate){
                    this.$message.error('请选择结束日期')
                }else if (!this.startDate){
                    this.$message.error('请选择开始日期')
                }else {
                    this.getList()
                }
                // this.foodType=this.cpTypedata.id

                //this.dcslist()
                //console.log(this.tableData)
                this.currentPage=1
            },
            //分页
            //监听pagesize改变的事件
            handleSizeChange(newsize) {
                //console.log(`每页 ${newsize} 条`);
                //最新的条数（newsize）赋值给 动态的 pageSize
                this.pageSize = newsize;    //动态改变
                this.getList()
                //获取到最新一页显示的数据  重新发送请求
                //this.clist()
                //this.dcslist()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                // console.log(`当前页: ${newPage}`);
                //把最新的页码（newPage）赋值给 动态的 currentPage
                this.currentPage = newPage;    //动态改变
                this.getList()
                //获取到最新页码值  重新发送请求
                //this.clist()
                //this.dcslist()
            },
            //新增菜品
            addMenu(){

                if(this.addbtn){
                    this.$message.error('下周菜品已新增,请勿重复操作');
                }else{
                    this.title='菜谱发布'
                    this.editShow=false
                    this.editbtn=2
                    this.editData={

                    }
                    this.addDialog=true

                }


            },
            //编辑菜品
            editDish(val){
                this.editData=val
                this.title='编辑菜谱'
                this.editbtn=3
                // if(val.state==0){
                    this.addDialog=true
                // if(val.state==1){
                //
                // }
                // }else {
                //     this.addDialog=false
                // }
            },


            //删除菜谱(父)
            del(val){
                this.title='删除'
                this.editData=val
                this.deldetail='是否要删除'
                this.delDialog=true

            },
            //菜谱确认作废(父)
            submitdel(){
                this.remove()
                this.delDialog=false
            },

            //发布
            cprelease(val){
                this.title='发布'
                this.releaseDate=val.week
                this.releasedetail='是否要发布'
                this.releaseDialog=true

            },
            //菜谱确认发布
            submitrelease(){
                this.menuRelease()
                this.releaselDialog=false
            },

            //菜谱列表
            async getList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    startDate:this.startDate,
                    endDate:this.endDate,
                    // foodType:this.foodType
                }
                let res = await API.getList(params);
                if (res.code == 1) {
                    this.moren=res.refundTimeout
                    this.addbtn=!res.addState
                    this.tableData=res.data
                    this.dateList=res.dateList
                    // console.log(res.data,'list')
                    this.total=res.total
                    // this.tableData.forEach(item=>{
                    //     item.createTime=item.createTime.substring(0,19)
                    // })
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            // 业务配置作废
            async remove() {
                // return
                // await this.getDetails()
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    // date:this.editData.date,
                    week:this.editData.week
                }
                let res = await API.remove(params);
                if (res.code == 1) {
                    this.getList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.$message.error(res.message);
                }
            },
            //菜谱发布
            async menuRelease(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    week:this.releaseDate
                }
                let res = await API.release(params);
                if (res.code == 1) {

                    this.releaseDialog=false
                    this.getList()
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    // this.$message.info(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

        },

    }
</script>

<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
        /* .cell{*/
        /*    height: 42px;*/
        /*    line-height: 23px;*/
        /*}*/
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }
    .titlew{
        padding: 0 10px;
        font-size: 14px;
    }
    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>